export const summaryElements = {
  netPay: 'netPay',
  totalCost: 'totalCost',
  workerEarningsTotal: 'workerEarningsTotal',
  workerDeductionsTotal: 'workerDeductionsTotal',
} as const;
